export default "__VITE_ASSET__s7J35HfQ__"